// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__hKyCO","Accordion":"Post_Accordion__5gX_E","AccordionContent":"Post_AccordionContent__qEnf3"};